import "./UserQuestionsPage.css";

import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import {
    getUserSurveysQuestions,
    submitUserSurveysResponse,
} from "../../../services/survey/survey-user";
import { useLocation, useNavigate } from "react-router-dom";

import Loader from "../../common/Loader/Loader";
import ModalComponent from "../../common/ModalComponent/ModalComponent";
import { toast } from "react-toastify";
import  renderWithLinks  from '../../../utils/linkGenerator';

// Import API function to fetch survey questions

const UserQuestionsPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { surveyId, surveyTitle, endDate, reloadKey, backgroundImage, languageMasterId } =
        location.state || {}; // Retrieve survey ID and title from navigation state
    const [loading, setLoading] = useState(false); // Loading state for API calls
    const [surveyData, setSurveyData] = useState([]); // State to hold fetched survey questions
    const [showModal, setShowModal] = useState(false);
    const [responses, setResponses] = useState({});
    const [groupedQuestions, setGroupedQuestions] = useState([]);
    const isExternalUserSurvey = sessionStorage.getItem("isExternalUserSurvey");
    const { t } = useTranslation();
    const [openSections, setOpenSections] = useState({ 0: true });
    const surveyPreview = sessionStorage.getItem("surveyPreview");

    // Fetch survey questions based on the survey ID
    useEffect(() => {
        fetchSurveyQuestions();
    }, [reloadKey]);

    useEffect(() => {
        if (isExternalUserSurvey === 'true') {
            sessionStorage.setItem("isExternalUserQuestionsPageOpen", true);
            const event = new Event('sessionStorageUpdated');
            window.dispatchEvent(event);
        }
    }, [isExternalUserSurvey])

    // Group and number questions after surveyData is loaded
    // useEffect(() => {
    //     if (!surveyData.length) return;

    //     // Group questions by section, sort so "No Section" is last, and assign unique numbers
    //     const sectionMap = {};
    //     surveyData.forEach((item) => {
    //         const section =
    //             item.sectionTitle && item.sectionTitle?.trim() !== ""
    //                 ? item.sectionTitle
    //                 : "";
    //         if (!sectionMap[section]) sectionMap[section] = [];
    //         sectionMap[section].push(item);
    //     });

    //     const sectionOrder = Object.keys(sectionMap).sort((a, b) => {
    //         if (a === "") return 1;
    //         if (b === "") return -1;
    //         return a.localeCompare(b);
    //     });

    //     let uniqueNumber = 1;
    //     const grouped = sectionOrder.map((section) => ({
    //         sectionTitle: section,
    //         questions: sectionMap[section].map((obj) => ({
    //             ...obj,
    //             uniqueNumber: uniqueNumber++,
    //         })),
    //     }));

    //     setGroupedQuestions(grouped);
    // }, [surveyData]);
        useEffect(() => {
            if (!surveyData.length) return;

            const sectionMap = {};
            const sectionOrder = [];

            surveyData.forEach((item) => {
                const section = item.sectionTitle?.trim() || "";

                if (!sectionMap[section]) {
                    sectionMap[section] = [];
                    sectionOrder.push(section); // ✅ preserve order
                }

                sectionMap[section].push(item);
            });

            let uniqueNumber = 1;

            const grouped = sectionOrder.map((section) => ({
                sectionTitle: section,
                questions: sectionMap[section].map((obj) => ({
                    ...obj,
                    uniqueNumber: uniqueNumber++,
                })),
            }));

            setGroupedQuestions(grouped);
        }, [surveyData]);
    const fetchSurveyQuestions = async () => {
        if (surveyId) {
            setLoading(true);
            try {
                const response = await getUserSurveysQuestions(surveyId, languageMasterId); // Fetch survey questions using the API;
                if (response.statusCode === 200 && response.data) {
                    setSurveyData(response.data); // Set the fetched survey data to state
                }
                setLoading(false);
            } catch (error) {
                console.error("Failed to fetch survey questions:", error);
                setLoading(false);
            }
        }
    };

    const handleSubmit = () => {
        // Get all required (mandatory) questions
        const requiredQuestions = surveyData.filter((obj) => obj?.isMandatory);

        // Check if each required question has a response
        const allRequiredAnswered = requiredQuestions.every(
            (item) =>
                responses[item.questionId] !== undefined &&
                responses[item.questionId] !== ""
        );

        if (!allRequiredAnswered) {
            toast.error(
                t("allQuestionsRequired"),
                {
                    position: "top-center",
                    theme: "dark",
                }
            );
            return;
        }
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const trimText = (text) => {
        return text?.trim()?.replace(/\s+/g, " ");
    };

    const handleConfirmSubmit = async () => {
        setLoading(true);
        const surveyQuestionList = surveyData.map((question) => {
            if (question.code === "FreeText") {
                return {
                    questionId: question.questionId,
                    questionTypeId: question.questionTypeId,
                    userAnswer: trimText(responses[question.questionId]) || "",
                    // userAnswer: encodeURIComponent(trimText(responses[question.questionId]) || ""),
                };
            }

            if (question.code === "OneWord") {
                return {
                    questionId: question.questionId,
                    questionTypeId: question.questionTypeId,
                    userAnswer: trimText(responses[question.questionId]) || "",
                    // userAnswer: encodeURIComponent(trimText(responses[question.questionId]) || ""),
                    surveyQuestionOptionsList: [
                        {
                            IsSelected: true,
                        },
                    ],
                };
            }

            if (question.code === "MCQ") {
                const selectedIds = Array.isArray(
                    responses[question.questionId]
                )
                    ? responses[question.questionId]
                    : [];
                return {
                    questionId: question.questionId,
                    questionTypeId: question.questionTypeId,
                    surveyQuestionOptionsList: Object.entries(
                        JSON.parse(question.options)
                    ).map(([key, value]) => ({
                        optionNumber: parseInt(key),
                        optionText: value,
                        isSelected: selectedIds.includes(parseInt(key)),
                    })),
                };
            }
            return {
                questionId: question.questionId,
                questionTypeId: question.questionTypeId,
                surveyQuestionOptionsList: Object.entries(
                    JSON.parse(question.options)
                ).map(([key, value]) => ({
                    optionNumber: parseInt(key),
                    optionText: value,
                    isSelected:
                        responses[question.questionId] === parseInt(key),
                })),
            };
        });

        // const userEmail = localStorage.getItem("userEmail");
        const payload = {
            surveyId: surveyId,
            surveyQuestionList,
        };
        try {
            const response = await submitUserSurveysResponse(payload, languageMasterId);
            if (response.statusCode === 200 && response.data) {
                navigate("/user/survey/opening-page/ques-page/response-page", {
                    state: { surveyTitle, endDate, backgroundImage },
                });
            }
            setLoading(false);
        } catch (error) {
            console.error("Failed to submit survey:", error);
            setLoading(false);
        }
        setShowModal(false);
    };

    const handleCancel = () => {
        if (surveyPreview === "true") {
            navigate("/admin/survey");
            sessionStorage.removeItem("surveyPreview");
        } else {
            navigate("/user/survey");
        }
    };

    const handleOptionChange = (optionsString) => {
        // Convert the string to an object
        const optionsObject = JSON.parse(optionsString);

        // Convert the object to an array of objects
        const optionsArray = Object.entries(optionsObject).map(
            ([key, value]) => ({
                id: parseInt(key),
                value: value,
            })
        );

        return optionsArray;
    };

    const toggleSection = (index) => {
        setOpenSections((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                // style={{ backgroundColor: `${backgroundImage?.color}` }}
                <div
                    className="ques-survey-bg"
                    style={{ backgroundColor: `${backgroundImage?.color}` }}
                >
                    <div className="ques-survey-page col-sm-12">
                        <div className="ques-survey-review-container">
                            <div className="ques-header">
                                <h2 className="ques-survey-title">
                                    <b>{surveyTitle}</b>
                                </h2>
                                {/* <p className="ques-required-text">
                  All questions marked with{" "}
                  <span className="ques-required">*</span> require answers.
                </p> */}
                                <p className="ques-required-text">
                                    <Trans i18nKey="allQuestionsRequired">
                                        {/* All questions marked with <span className="ques-required">*</span> require answers. */}
                                        All mandatory questions are marked with{" "}
                                    </Trans>
                                    <span className="ques-required">*</span>
                                </p>
                            </div>

                            {/* Scrollable container for questions */}
                            <div className="ques-scroll-container">
                                {groupedQuestions.map((section, sectionIdx) => (
                                    <div
                                        key={section.sectionTitle}
                                        className={
                                            "ques-survey-section" +
                                            (sectionIdx !==
                                            groupedQuestions.length - 1
                                                ? " ques-section-border"
                                                : "")
                                        }
                                    >
                                        <div
                                            className="ques-section-header"
                                            onClick={() =>
                                                toggleSection(sectionIdx)
                                            }
                                        >
                                            <h3 className="ques-sub-title">
                                                {section.sectionTitle === ""
                                                    ? t("untitled")
                                                    : section.sectionTitle}
                                            </h3>
                                            <span
                                                style={{
                                                    fontSize: "20px",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {openSections[sectionIdx]
                                                    ? "-"
                                                    : "+"}
                                            </span>
                                        </div>

                                        {openSections[sectionIdx] &&
                                            section.questions.map(
                                                (item, idx) => (
                                                    <div
                                                        key={`question-${item.questionId}`}
                                                        className="ques-question-container"
                                                    >
                                                        <p className="ques-question-text">
                                                            {item.uniqueNumber}.
                                                            {item.isMandatory && (
                                                                <span className="ques-required">
                                                                    *
                                                                </span>
                                                            )}{" "}
                                                            {renderWithLinks(item.questionText)}
                                                        </p>

                                                        {/* Multiple-Choice Options */}
                                                        {item.code ===
                                                            "SCQ" && (
                                                            <div className="ques-options-container">
                                                                <div className="ques-options-scq">
                                                                    {handleOptionChange(
                                                                        item.options
                                                                    ).map(
                                                                        (
                                                                            option,
                                                                            i
                                                                        ) => (
                                                                            <label
                                                                                key={`scq-${item.questionId}-${option.id}`}
                                                                                className="ques-option-label"
                                                                            >
                                                                                <input
                                                                                    type="radio"
                                                                                    name={`mcq-${item.questionId}`}
                                                                                    value={
                                                                                        option.id
                                                                                    }
                                                                                    checked={
                                                                                        responses[
                                                                                            item
                                                                                                .questionId
                                                                                        ] ===
                                                                                        option.id
                                                                                    }
                                                                                    onChange={() =>
                                                                                        setResponses(
                                                                                            (
                                                                                                prev
                                                                                            ) => ({
                                                                                                ...prev,
                                                                                                [item.questionId]:
                                                                                                    option.id,
                                                                                            })
                                                                                        )
                                                                                    }
                                                                                    style={{
                                                                                        accentColor:
                                                                                            "#B1000E",
                                                                                    }}
                                                                                    disabled={
                                                                                        surveyPreview ===
                                                                                        "true"
                                                                                    }
                                                                                />
                                                                                {
                                                                                    option.value
                                                                                }
                                                                            </label>
                                                                        )
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}

                                                        {item.code ===
                                                            "MCQ" && (
                                                            <div className="ques-options-container">
                                                                <div className="ques-options-mcq">
                                                                    {handleOptionChange(
                                                                        item.options
                                                                    ).map(
                                                                        (
                                                                            option,
                                                                            i
                                                                        ) => (
                                                                            <label
                                                                                key={`mcq-${item.questionId}-${option.id}`}
                                                                                className="ques-option-label"
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    name={`mcq-${item.questionId}`}
                                                                                    value={
                                                                                        option.id
                                                                                    }
                                                                                    checked={
                                                                                        Array.isArray(
                                                                                            responses[
                                                                                                item
                                                                                                    .questionId
                                                                                            ]
                                                                                        ) &&
                                                                                        responses[
                                                                                            item
                                                                                                .questionId
                                                                                        ].includes(
                                                                                            option.id
                                                                                        )
                                                                                    }
                                                                                    onChange={(
                                                                                        e
                                                                                    ) => {
                                                                                        setResponses(
                                                                                            (
                                                                                                prev
                                                                                            ) => {
                                                                                                const prevArr =
                                                                                                    Array.isArray(
                                                                                                        prev[
                                                                                                            item
                                                                                                                .questionId
                                                                                                        ]
                                                                                                    )
                                                                                                        ? prev[
                                                                                                              item
                                                                                                                  .questionId
                                                                                                          ]
                                                                                                        : [];
                                                                                                if (
                                                                                                    e
                                                                                                        .target
                                                                                                        .checked
                                                                                                ) {
                                                                                                    return {
                                                                                                        ...prev,
                                                                                                        [item.questionId]:
                                                                                                            [
                                                                                                                ...prevArr,
                                                                                                                option.id,
                                                                                                            ],
                                                                                                    };
                                                                                                } else {
                                                                                                    return {
                                                                                                        ...prev,
                                                                                                        [item.questionId]:
                                                                                                            prevArr.filter(
                                                                                                                (
                                                                                                                    id
                                                                                                                ) =>
                                                                                                                    id !==
                                                                                                                    option.id
                                                                                                            ),
                                                                                                    };
                                                                                                }
                                                                                            }
                                                                                        );
                                                                                    }}
                                                                                    style={{
                                                                                        accentColor:
                                                                                            "#B1000E",
                                                                                    }}
                                                                                    disabled={
                                                                                        surveyPreview ===
                                                                                        "true"
                                                                                    }
                                                                                />
                                                                                {
                                                                                    option.value
                                                                                }
                                                                            </label>
                                                                        )
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* Yes/No Options */}
                                                        {(item?.code ===
                                                            "YesNo" ||
                                                            item?.code ===
                                                                "TrueFalse") && (
                                                            <div className="ques-options-container">
                                                                <div className="ques-yes-no-options">
                                                                    {handleOptionChange(
                                                                        item.options
                                                                    ).map(
                                                                        (
                                                                            option,
                                                                            i
                                                                        ) => (
                                                                            <label
                                                                                key={`yesno-${item.questionId}-${option.id}`}
                                                                                className="ques-yes-no-label"
                                                                            >
                                                                                <input
                                                                                    type="radio"
                                                                                    name={`question-${item.questionId}`}
                                                                                    value={
                                                                                        option.id
                                                                                    }
                                                                                    checked={
                                                                                        responses[
                                                                                            item
                                                                                                .questionId
                                                                                        ] ===
                                                                                        option.id
                                                                                    }
                                                                                    onChange={() =>
                                                                                        setResponses(
                                                                                            (
                                                                                                prev
                                                                                            ) => ({
                                                                                                ...prev,
                                                                                                [item.questionId]:
                                                                                                    option.id,
                                                                                            })
                                                                                        )
                                                                                    }
                                                                                    style={{
                                                                                        accentColor:
                                                                                            "#B1000E",
                                                                                    }}
                                                                                    disabled={
                                                                                        surveyPreview ===
                                                                                        "true"
                                                                                    }
                                                                                />
                                                                                {
                                                                                    t(option.value)
                                                                                }
                                                                            </label>
                                                                        )
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* Text Input */}
                                                        {item.code ===
                                                            "OneWord" && (
                                                            <div className="ques-options-container">
                                                                <input
                                                                    type="text"
                                                                    className="ques-text-answer"
                                                                    placeholder={t("typeAnswer")}
                                                                    value={
                                                                        responses[
                                                                            item
                                                                                .questionId
                                                                        ] || ""
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        const value =
                                                                            e
                                                                                .target
                                                                                .value;
                                                                        toast.dismiss();
                                                                        if (
                                                                            value.length >
                                                                            20
                                                                        ) {
                                                                            toast.error(t("answerExceedsMaxLengthError", { number: 20 }), {
                                                                                position: "top-center",
                                                                            });
                                                                            return;
                                                                        }
                                                                        setResponses(
                                                                            (
                                                                                prev
                                                                            ) => ({
                                                                                ...prev,
                                                                                [item.questionId]:
                                                                                    value,
                                                                            })
                                                                        );
                                                                    }}
                                                                    disabled={
                                                                        surveyPreview ===
                                                                        "true"
                                                                    }
                                                                />
                                                                <div
                                                                    style={{
                                                                        fontSize:
                                                                            "12px",
                                                                        color: "#888",
                                                                        marginTop:
                                                                            "2px",
                                                                    }}
                                                                >
                                                                    {
                                                                        (
                                                                            responses[
                                                                                item
                                                                                    .questionId
                                                                            ] ||
                                                                            ""
                                                                        ).length
                                                                    }
                                                                    /20
                                                                </div>
                                                            </div>
                                                        )}

                                                        {item.code ===
                                                            "FreeText" && (
                                                            <div className="ques-options-container">
                                                                <textarea
                                                                    // type="text"
                                                                    row={6}
                                                                    className="ques-text-answer"
                                                                    placeholder={t("typeAnswer")}
                                                                    value={
                                                                        responses[
                                                                            item
                                                                                .questionId
                                                                        ] || ""
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        const value =
                                                                            e
                                                                                .target
                                                                                .value;
                                                                        toast.dismiss();
                                                                        // Block input beyond 500 characters
                                                                        if (
                                                                            value.length >
                                                                            255
                                                                        ) {
                                                                            toast.error(
                                                                                t("answerExceedsMaxLengthError", { number: 255 }),
                                                                                {
                                                                                    position: "top-center",
                                                                                }
                                                                            );
                                                                            return;
                                                                        }

                                                                        // Update state if within the limit
                                                                        setResponses(
                                                                            (
                                                                                prev
                                                                            ) => ({
                                                                                ...prev,
                                                                                [item.questionId]:
                                                                                    value,
                                                                            })
                                                                        );
                                                                    }}
                                                                    disabled={
                                                                        surveyPreview ===
                                                                        "true"
                                                                    }
                                                                />
                                                                <div
                                                                    style={{
                                                                        fontSize:
                                                                            "12px",
                                                                        color: "#888",
                                                                        marginTop:
                                                                            "2px",
                                                                    }}
                                                                >
                                                                    {
                                                                        (
                                                                            responses[
                                                                                item
                                                                                    .questionId
                                                                            ] ||
                                                                            ""
                                                                        ).length
                                                                    }
                                                                    /255
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )
                                            )}
                                    </div>
                                ))}
                            </div>

                            <div className="ques-button-container">
                                {!surveyPreview && (
                                    <button
                                        className="saveButton"
                                        onClick={handleSubmit}
                                    >
                                        {t("submit")}
                                    </button>
                                )}

                                {isExternalUserSurvey === "false" && (
                                    <button
                                        className="cancelButton"
                                        onClick={handleCancel}
                                    >
                                        {!surveyPreview
                                            ? t("cancel")
                                            : t("back")}
                                    </button>
                                )}
                            </div>

                            {/* Reusable Modal Component */}
                            <ModalComponent
                                isOpen={showModal}
                                onClose={handleCloseModal}
                                modalTitle={t("submitSurvey")}
                                modalText={t("areYouSureSubmit")}
                                buttons={[
                                    <button
                                        key="confirm"
                                        className="saveButton"
                                        onClick={handleConfirmSubmit}
                                    >
                                        {t("confirm")}
                                    </button>,
                                    <button
                                        key="cancel"
                                        className="cancelButton"
                                        onClick={handleCloseModal}
                                    >
                                        {t("cancel")}
                                    </button>,
                                ]}
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default UserQuestionsPage;
